import { render } from "./HandleQuestions.vue?vue&type=template&id=2898aabf"
import script from "./HandleQuestions.vue?vue&type=script&lang=ts"
export * from "./HandleQuestions.vue?vue&type=script&lang=ts"
script.render = render

export default script